////////LIBRARY/////////
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const UseModalPosY = (showModal) => {
	const [winPos, setWinPos] = useState({
		windowPageYOffset: window.pageYOffset,
		windowPageXOffset: window.pageXOffset,
	})

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const onScrollHandler = () => {
		window.scrollTo(winPos.windowPageXOffset, winPos.windowPageYOffset)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		setWinPos({
			windowPageYOffset: window.pageYOffset,
			windowPageXOffset: window.pageXOffset,
		})
		if (showModal) {
			window.addEventListener('scroll', onScrollHandler)
		} else {
			window.removeEventListener('scroll', onScrollHandler)
		}
	}, [showModal])

	useEffect(() => {
		return () => {
			window.removeEventListener('scroll', onScrollHandler)
		}
	})

	///////////////////////////////// RENDER ///////////////////////////////////////

	return [winPos]
}

UseModalPosY.propTypes = {
	showModal: PropTypes.bool,
}

UseModalPosY.defaultPropTypes = {}

export default UseModalPosY
